import { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import { LoadingAnimation } from "../../Service/ResourceAdapter";
import { getDocumentTranslator } from "../Document/documentLanguage";
import { useLingui } from "@lingui/react";
import { isDefined } from "../../Utils/utils";

const BankAccountAndTaxNumbers = ({ language }) => {
  const { profile, bankAccount, loading } = useContext(ResourceContext);
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, language);

  if (loading) {
    return <LoadingAnimation />;
  }
  const styles = {
    listStyle: {
      display: "block",
      listStyleType: "none",
      marginBottom: 5,
      paddingLeft: 0,
      flexWrap: "wrap",
    },
    itemStyle: {
      marginRight: "unset",
      fontSize: 12,
      whiteSpace: "nowrap",
    },
  };
  const {
    taxNumber,
    vatId
  } = profile;

  const {
    iban
  } = bankAccount ?? {};

  return (
    <ul style={styles.listStyle}>
      {isDefined(iban) && (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            <span>IBAN:</span>
            {" "}
            <span>{iban}</span>
          </li>
      )}
      {isDefined(vatId) && (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            <span>{t("vatIdLabel")}:</span>
            {" "}
            <span>{vatId}</span>
          </li>
      )}
      {isDefined(taxNumber) && (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            <span>{t("taxNumberLabel")}:</span>
            {" "}
            <span>{taxNumber}</span>
          </li>
      )}
    </ul>
  );
};

export default BankAccountAndTaxNumbers;
